import io from "socket.io-client";

export const socket = io("https://hot.uruz.id/layout");
